import type {
  AuthByLoginOrEmailUserInput,
  AuthByOneTimeAuthCodeInput,
  AuthByOTPUserInput,
  AuthByPhoneAndPasswordInput,
} from "@litres-libs/types";
import type { TLoginRequest } from "./auth.types";

export const isAuthByOTPUserInput = (
  payload: TLoginRequest
): payload is AuthByOTPUserInput => "otp_id" in payload && "code" in payload;

export const isAuthByLoginOrEmailUserInput = (
  payload: TLoginRequest
): payload is AuthByLoginOrEmailUserInput =>
  "login" in payload && "password" in payload;

export const isAuthByPhoneAndPasswordInput = (
  payload: TLoginRequest
): payload is AuthByPhoneAndPasswordInput =>
  "phone" in payload && "country_code" in payload;

export const isAuthByOneTimeCodeInput = (
  payload: TLoginRequest
): payload is AuthByOneTimeAuthCodeInput =>
  "code" in payload && !("otp_id" in payload);
